import React, { useState } from 'react';
import { useToast } from '../../components/common';
import api from '../../services/api';

/** The shelves a store sorts apps and plugins onto (third_parties.category,
 *  migration 277). The backend refuses anything else. */
export const CATEGORIES = [
  { value: 'mind', label: 'Mind' },
  { value: 'body', label: 'Body' },
  { value: 'money', label: 'Money' },
  { value: 'words', label: 'Words' },
  { value: 'voice', label: 'Voice' },
  { value: 'build', label: 'Build' },
];
export const CATEGORY_HELP = 'The shelf it sits on in the store. People filter by it.';

/**
 * An app's or plugin's category, as a row of chips: the chosen one lit, a press
 * on another moves it, a press on the lit one clears it. Saved on press.
 *
 * NOT STAGED, like the logo: a category is presentation. It changes where the
 * app is shelved, not what it is or what it asks for, so it cuts no version and
 * goes live at once.
 *
 * It was a <Select block>, whose shell form cell carries page-scale padding
 * (44px) — the indented "CATEGORY / Not chosen" block. Chips are one row.
 */
function CategoryField({ item, onSaved }) {
  const toast = useToast();
  const [value, setValue] = useState(item.category || '');
  const [busy, setBusy] = useState(false);
  const isApp = item._type === 'app';

  const choose = async (picked) => {
    const next = picked === value ? '' : picked;
    const prev = value;
    setValue(next);
    setBusy(true);
    try {
      const body = { category: next || null };
      await (isApp ? api.updateThirdParty(item.id, body) : api.updatePlugin(item.id, body));
      toast.success(next ? `Shelved under ${CATEGORIES.find((c) => c.value === next).label}.` : 'Category cleared.');
      await onSaved?.();
    } catch (err) {
      setValue(prev);
      toast.error(err?.message || 'The category did not save.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="appfield appfield--readonly catfield">
      <span className="appfield__label">Category</span>
      <div className="appfield__value catfield__chips" role="radiogroup" aria-label="Category">
        {CATEGORIES.map((c) => (
          <button
            key={c.value}
            type="button"
            role="radio"
            aria-checked={value === c.value}
            className={`catfield__chip${value === c.value ? ' is-on' : ''}`}
            disabled={busy}
            onClick={() => choose(c.value)}
          >
            {c.label}
          </button>
        ))}
      </div>
      <span />
    </div>
  );
}

export default CategoryField;
